import React from 'react';
import Navigation from 'components/Navigation';
import Hero from 'components/Hero';
import About from 'components/About';
import Experience from 'components/Experience';
import Projects from 'components/Projects';
import Articles from 'components/Articles';
import Contact from 'components/Contact';
import Footer from 'components/Footer';
import ScrollToTop from 'components/ScrollToTop';
import { BLOG_URL } from 'lib/constants';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main>
        <div id="home" className="scroll-mt-16">
          <Hero />
        </div>
        
        <div id="about" className="scroll-mt-16">
          <About />
        </div>
        
        <div id="experience" className="scroll-mt-16">
          <Experience />
        </div>

        <div id="projects" className="scroll-mt-16">
          <Projects />
        </div>
        
        {BLOG_URL && (
          <div id="articles" className="scroll-mt-16">
            <Articles url={BLOG_URL} />
          </div>
        )}
        
        <div id="contact" className="scroll-mt-16">
          <Contact />
        </div>
      </main>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Home;
